interface IFProps {
  condition: boolean;
  children: any;
}
export function IF({ condition, children }: IFProps) {
  if (condition) {
    return children;
  }

  return null;
}
